import React, { createContext, useContext, useState, useEffect } from 'react';
import { createFavoriteApiService } from '../utils/favoriteApiService';
import { useJWTAuth } from '../context/JWTAuthContext';

const FavoriteContext = createContext();

export const FavoriteProvider = ({ children }) => {
  const [favoriteStocks, setFavoriteStocks] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const { apiCall, isAuthenticated, isLoading } = useJWTAuth();

  console.log('🌟 [FavoriteContext] apiCall 함수:', typeof apiCall, 'isAuthenticated:', isAuthenticated, 'isLoading:', isLoading);

  const favoriteApi = createFavoriteApiService(apiCall);

  // 초기 로드
  const loadFavorites = async () => {
    // 인증되지 않은 경우 로드하지 않음
    if (!isAuthenticated) {
      console.log('🌟 [FavoriteContext] 인증되지 않음 - 즐겨찾기 로드 건너뜀');
      return;
    }

    setLoading(true);
    try {
      console.log('🌟 [FavoriteContext] 즐겨찾기 로드 시작 (isAuthenticated:', isAuthenticated, ')');
      console.log('🌟 [FavoriteContext] apiCall 타입:', typeof apiCall);
      const response = await favoriteApi.getFavorites();
      const stockCodes = response.map(fav => fav.stock_code);
      setFavoriteStocks(new Set(stockCodes));
      console.log('🌟 [FavoriteContext] 즐겨찾기 로드 완료:', stockCodes.length, '개');
    } catch (error) {
      console.error('❌ [FavoriteContext] 즐겨찾기 로드 실패:', error);
      console.error('❌ [FavoriteContext] 에러 상세:', error.message, error.stack);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 인증 로딩이 완료되고, 인증된 경우에만 즐겨찾기 로드
    if (!isLoading && isAuthenticated) {
      loadFavorites();
    }
    // eslint-disable-next-line
  }, [isLoading, isAuthenticated]);

  const toggleFavorite = async (stockCode) => {
    const isFavorite = favoriteStocks.has(stockCode);

    try {
      if (isFavorite) {
        await favoriteApi.removeFavorite(stockCode);
        setFavoriteStocks(prev => {
          const next = new Set(prev);
          next.delete(stockCode);
          return next;
        });
      } else {
        await favoriteApi.addFavorite(stockCode);
        setFavoriteStocks(prev => new Set([...prev, stockCode]));
      }
    } catch (error) {
      console.error('Failed to toggle favorite:', error);
      throw error;
    }
  };

  return (
    <FavoriteContext.Provider value={{
      favoriteStocks,
      toggleFavorite,
      loadFavorites,
      loading
    }}>
      {children}
    </FavoriteContext.Provider>
  );
};

export const useFavorites = () => {
  const context = useContext(FavoriteContext);
  if (!context) {
    throw new Error('useFavorites must be used within FavoriteProvider');
  }
  return context;
};
